<template>
  <div id="confirmation">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'confirmation'
}
</script>


// WEBPACK FOOTER //
// src/views/exhibitorsUpload/Confirmation.vue